import { useInitializeDocumentFilters, useInitializeDocumentTypes } from './hooks'

export const DocumentsInitialization = () => {
  useInitializeDocumentTypes()
  useInitializeDocumentFilters()

  return null
}
